import styled from 'styled-components';
import { FlexContainer } from 'utils/layouts/containers';
import { Typography } from 'antd';
import { Button, Collapse } from 'components/ui';

const { Text, Title } = Typography;

export const StyledError = styled(FlexContainer)`
  flex-direction: column;
  justify-content: center;
  margin-top: 1rem;
`;

export const ErrorContainer = styled(FlexContainer)`
  background-color: ${({ theme }) => theme.primaryBackgroundColor};
  flex-direction: column;
  height: 100%;
  justify-content: center;
  align-items: center;
  align-content: center;
  padding: 10% 25% 10% 25%;
  width: 100%;
`;

export const FallbackContainer = styled(FlexContainer)`
  flex-direction: column;
  justify-content: center;
  align-content: stretch;
  margin: 0 15% 0 15%;
`;

export const StyledText = styled(Text)`
  color: ${({ theme }) => theme.headerColor};
  margin: 1rem 0;
  text-align: center;
`;

export const StyledImage = styled.img`
  padding: 0.5em 1em;
  height: 150px;
`;

export const StyledButton = styled(Button)`
  padding: 10 5;
`;

export const StyledCollapse = styled(Collapse)`
  align-self: stretch;
`;

export const StyledErrorMessage = styled.pre`
  align-self: flex-start;
  text-align: start;
  padding: 10px;
  background: ${({ theme }) => theme.yellow} background;
`;

export const StyledTitle = styled(Title)`
  color: ${({ theme }) => theme.headerColor} !important;
  text-align: center;
`;
